import {take} from 'redux-saga/effects';
import {handleError} from 'helpers';

export function* error() {
  while (true) {
    const { error, extra } = yield take(action => action.error);
    handleError(error, { extra });
  }
}
